import { SharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalComponent } from './internal.component';
import { InternalAccesoComponent } from './internal-acceso/internal-acceso.component';
import { InternalHomeComponent } from './internal-home/internal-home.component';
import { InternalRoutingModule } from './internal-routing.module';
import { InternalAccesoService } from './internal-acceso/internal-acceso.service';
import { InternalHomeService } from './internal-home/internal-home.service';
import { AplicationdefsComponent } from './internal-home/pages/aplicationdefs/aplicationdefs.component';
import { ParametersComponent } from './internal-home/pages/parameters/parameters.component';
import { CasComponent } from './internal-home/pages/cas/cas.component';
import { WsdefsComponent } from './internal-home/pages/wsdefs/wsdefs.component';
import { SetvaluesComponent } from './internal-home/pages/setvalues/setvalues.component';
import { TypefindersComponent } from './internal-home/pages/typefinders/typefinders.component';
import { TyperunsComponent } from './internal-home/pages/typeruns/typeruns.component';
import { XmldefsComponent } from './internal-home/pages/xmldefs/xmldefs.component';
import { FieldtypesComponent } from './internal-home/pages/fieldtypes/fieldtypes.component';
import { FieldlinksComponent } from './internal-home/pages/fieldlinks/fieldlinks.component';
import { DbattrsComponent } from './internal-home/pages/dbattrs/dbattrs.component';
import { DbmodelsComponent } from './internal-home/pages/dbmodels/dbmodels.component';
import { DbindicesComponent } from './internal-home/pages/dbindices/dbindices.component';
import { DbindexfldsComponent } from './internal-home/pages/dbindexflds/dbindexflds.component';
import { TextsComponent } from './internal-home/pages/texts/texts.component';
import { NoticesComponent } from './internal-home/pages/notices/notices.component';
import { StatisticsComponent } from './internal-home/pages/statistics/statistics.component';
import { StatistisexteranlComponent } from './internal-home/pages/statistisexteranl/statistisexteranl.component';
import { RolinternalComponent } from './internal-home/pages/rolinternal/rolinternal.component';
import { RolexternalComponent } from './internal-home/pages/rolexternal/rolexternal.component';
import { EditDialogsParametersComponent } from './internal-home/pages/parameters/dialogs-parameters/edit-dialogs-parameters/edit-dialogs-parameters.component';
import { EditDialogsParametersService } from './internal-home/pages/parameters/dialogs-parameters/edit-dialogs-parameters/edit-dialogs-parameters.service';
import { EditDialogsWsdefsComponent } from './internal-home/pages/wsdefs/dialogs-wsdefs/edit-dialogs-wsdefs/edit-dialogs-wsdefs.component';
import { EditDialogsWsdefsService } from './internal-home/pages/wsdefs/dialogs-wsdefs/edit-dialogs-wsdefs/edit-dialogs-wsdefs.service';
import { EditDialogsSetvaluesComponent } from './internal-home/pages/setvalues/dialogs-setvalues/edit-dialogs-setvalues/edit-dialogs-setvalues.component';
import { EditDialogsSetValuesService } from './internal-home/pages/setvalues/dialogs-setvalues/edit-dialogs-setvalues/edit-dialogs-setvalues.service';
import { EditDialogsTypefindersComponent } from './internal-home/pages/typefinders/dialogs-typefinders/edit-dialogs-typefinders/edit-dialogs-typefinders.component';
import { EditDialogsTypefindersService } from './internal-home/pages/typefinders/dialogs-typefinders/edit-dialogs-typefinders/edit-dialogs-typefinders.service';
import { EditDialogsTyperunsComponent } from './internal-home/pages/typeruns/dialogs-typeruns/edit-dialogs-typeruns/edit-dialogs-typeruns.component';
import { EditDialogsTyperunsService } from './internal-home/pages/typeruns/dialogs-typeruns/edit-dialogs-typeruns/edit-dialogs-typeruns.service';
import { EditDialogsXmldefsComponent } from './internal-home/pages/xmldefs/dialogs-xmldefs/edit-dialogs-xmldefs/edit-dialogs-xmldefs.component';
import { EditDialogsXmldefsService } from './internal-home/pages/xmldefs/dialogs-xmldefs/edit-dialogs-xmldefs/edit-dialogs-xmldefs.service';
import { EditDialogsFieldtypesComponent } from './internal-home/pages/fieldtypes/dialogs-fieldtypes/edit-dialogs-fieldtypes/edit-dialogs-fieldtypes.component';
import { EditDialogsFieldtypesService } from './internal-home/pages/fieldtypes/dialogs-fieldtypes/edit-dialogs-fieldtypes/edit-dialogs-fieldtypes.service';
import { EditDialogsDbattrsComponent } from './internal-home/pages/dbattrs/dialogs-dbattrs/edit-dialogs-dbattrs/edit-dialogs-dbattrs.component';
import { EditDialogsDbattrsService } from './internal-home/pages/dbattrs/dialogs-dbattrs/edit-dialogs-dbattrs/edit-dialogs-dbattrs.service';
import { EditDialogsDbmodelsComponent } from './internal-home/pages/dbmodels/dialogs-dbmodels/edit-dialogs-dbmodels/edit-dialogs-dbmodels.component';
import { EditDialogsDbmodelsService } from './internal-home/pages/dbmodels/dialogs-dbmodels/edit-dialogs-dbmodels/edit-dialogs-dbmodels.service';
import { EditDialogsDbindicesComponent } from './internal-home/pages/dbindices/dialogs-dbindices/edit-dialogs-dbindices/edit-dialogs-dbindices.component';
import { EditDialogsDbindicesService } from './internal-home/pages/dbindices/dialogs-dbindices/edit-dialogs-dbindices/edit-dialogs-dbindices.service';
import { EditDialogsApplicationdefsComponent } from './internal-home/pages/aplicationdefs/dialogs-applicationdefs/edit-dialogs-applicationdefs/edit-dialogs-applicationdefs.component';
import { EditDialogsApplicationdefsService } from './internal-home/pages/aplicationdefs/dialogs-applicationdefs/edit-dialogs-applicationdefs/edit-dialogs-applicationdefs.service';
import { EditDialogsCasComponent } from './internal-home/pages/cas/dialogs-cas/edit-dialogs-cas/edit-dialogs-cas.component';
import { EditDialogsCasService } from './internal-home/pages/cas/dialogs-cas/edit-dialogs-cas/edit-dialogs-cas.service';
import { EditDialogsFieldlinksComponent } from './internal-home/pages/fieldlinks/dialogs-fieldlinks/edit-dialogs-fieldlinks/edit-dialogs-fieldlinks.component';
import { EditDialogsFieldlinksService } from './internal-home/pages/fieldlinks/dialogs-fieldlinks/edit-dialogs-fieldlinks/edit-dialogs-fieldlinks.service';
import { EditDialogsTextsComponent } from './internal-home/pages/texts/dialogs-texts/edit-dialogs-texts/edit-dialogs-texts.component';
import { EditDialogsTextsService } from './internal-home/pages/texts/dialogs-texts/edit-dialogs-texts/edit-dialogs-texts.service';
import { EditDialogsNoticesComponent } from './internal-home/pages/notices/dialogs-notices/edit-dialogs-notices/edit-dialogs-notices.component';
import { EditDialogsNoticesService } from './internal-home/pages/notices/dialogs-notices/edit-dialogs-notices/edit-dialogs-notices.service';
import { CampsComponent } from './internal-home/pages/xmldefs/camps/camps.component';
import { CampsService } from './internal-home/pages/xmldefs/camps/camps.service';
import { EditDialogsXmlfieldsComponent } from './internal-home/pages/xmldefs/dialogs-xmlfields/edit-dialogs-xmlfields/edit-dialogs-xmlfields.component';
import { EditDialogsXmlfieldsService } from './internal-home/pages/xmldefs/dialogs-xmlfields/edit-dialogs-xmlfields/edit-dialogs-xmlfields.service';
import { ViewDialogsDbindicesComponent } from './internal-home/pages/dbindices/dialogs-dbindices/view-dialogs-dbindices/view-dialogs-dbindices.component';
import { ViewDialogsDbindicesService } from './internal-home/pages/dbindices/dialogs-dbindices/view-dialogs-dbindices/view-dialogs-dbindices.service';
import { EditDialogsDbindexfldsComponent } from './internal-home/pages/dbindexflds/dialogs-dbindexflds/edit-dialogs-dbindexflds/edit-dialogs-dbindexflds.component';
import { EditDialogsDbindexfldsService } from './internal-home/pages/dbindexflds/dialogs-dbindexflds/edit-dialogs-dbindexflds/edit-dialogs-dbindexflds.service';
import { EditDialogsRolexternalComponent } from './internal-home/pages/rolexternal/dialogs-rolexternal/edit-dialogs-rolexternal/edit-dialogs-rolexternal.component';
import { EditDialogsRolExternalService } from './internal-home/pages/rolexternal/dialogs-rolexternal/edit-dialogs-rolexternal/edit-dialogs-rolexternal.service';
import { EditDialogsRolinternalComponent } from './internal-home/pages/rolinternal/dialogs-rolinternal/edit-dialogs-rolinternal/edit-dialogs-rolinternal.component';
import { EditDialogsRolInternalService } from './internal-home/pages/rolinternal/dialogs-rolinternal/edit-dialogs-rolinternal/edit-dialogs-rolinternal.service';
import { WebservicesComponent } from './internal-home/pages/webservices/webservices.component';
import { WebServicesService } from './internal-home/pages/webservices/webservices.service';
@NgModule({
    declarations: [
        InternalComponent,
        InternalAccesoComponent,
        InternalHomeComponent,
        AplicationdefsComponent,
        ParametersComponent,
        CasComponent,
        WsdefsComponent,
        SetvaluesComponent,
        TypefindersComponent,
        TyperunsComponent,
        XmldefsComponent,
        FieldtypesComponent,
        FieldlinksComponent,
        DbattrsComponent,
        DbmodelsComponent,
        DbindicesComponent,
        CampsComponent,
        TextsComponent,
        NoticesComponent,
        StatisticsComponent,
        StatistisexteranlComponent,
        DbindexfldsComponent,
        WebservicesComponent,
        RolexternalComponent,
        RolinternalComponent,
        EditDialogsParametersComponent,
        EditDialogsWsdefsComponent,
        EditDialogsSetvaluesComponent,
        EditDialogsTypefindersComponent,
        EditDialogsTyperunsComponent,
        EditDialogsXmldefsComponent,
        EditDialogsFieldtypesComponent,
        EditDialogsDbattrsComponent,
        EditDialogsDbmodelsComponent,
        EditDialogsDbindicesComponent,
        EditDialogsApplicationdefsComponent,
        EditDialogsCasComponent,
        EditDialogsFieldlinksComponent,
        EditDialogsTextsComponent,
        EditDialogsNoticesComponent,
        EditDialogsXmlfieldsComponent,
        ViewDialogsDbindicesComponent,
        EditDialogsDbindexfldsComponent,
        EditDialogsRolexternalComponent,
        EditDialogsRolinternalComponent
    ],
    exports: [
        EditDialogsParametersComponent,
        EditDialogsWsdefsComponent,
        EditDialogsSetvaluesComponent,
        EditDialogsTypefindersComponent,
        EditDialogsTyperunsComponent,
        EditDialogsXmldefsComponent,
        EditDialogsFieldtypesComponent,
        EditDialogsDbattrsComponent,
        EditDialogsDbmodelsComponent,
        EditDialogsDbindicesComponent,
        EditDialogsApplicationdefsComponent,
        EditDialogsCasComponent,
        EditDialogsFieldlinksComponent,
        CampsComponent,
        EditDialogsXmlfieldsComponent,
        ViewDialogsDbindicesComponent,
        DbindexfldsComponent,
        EditDialogsDbindexfldsComponent,
        EditDialogsTextsComponent,
        EditDialogsNoticesComponent,
        EditDialogsRolexternalComponent,
        EditDialogsRolinternalComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        InternalRoutingModule
    ],
    providers: [
        InternalAccesoService,
        InternalHomeService,
        EditDialogsParametersService,
        EditDialogsWsdefsService,
        EditDialogsSetValuesService,
        EditDialogsTypefindersService,
        EditDialogsTyperunsService,
        EditDialogsXmldefsService,
        EditDialogsFieldtypesService,
        EditDialogsDbattrsService,
        EditDialogsDbmodelsService,
        EditDialogsDbindicesService,
        EditDialogsApplicationdefsService,
        EditDialogsCasService,
        EditDialogsFieldlinksService,
        EditDialogsTextsService,
        EditDialogsNoticesService,
        CampsService,
        EditDialogsXmlfieldsService,
        ViewDialogsDbindicesService,
        EditDialogsDbindexfldsService,
        WebServicesService,
        EditDialogsRolExternalService,
        EditDialogsRolInternalService
    ]
})
export class InternalModule { }
